'use strict';
'use es6';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.playbackMessages = undefined;

var _q = require('q');

var _q2 = _interopRequireDefault(_q);

var _fetchHistory = require('./fetchHistory');

var _parseAblyMessage = require('../operators/parseAblyMessage');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var sortByTimestamp = function sortByTimestamp(historyItems) {
  return historyItems.sort(function (a, b) {
    return a.timestamp - b.timestamp;
  });
};

var playbackMessages = exports.playbackMessages = function playbackMessages(channels, channelId, startTime, onMessage) {
  return new _q2.default.Promise(function (resolve, reject) {
    var channel = channels.get(channelId);

    (0, _fetchHistory.fetchHistory)(channel, { start: startTime }).then(function (historyItems) {
      sortByTimestamp(historyItems).forEach(function (item) {
        var parsedMessage = (0, _parseAblyMessage.parseAblyMessage)(item);
        onMessage(parsedMessage);
      });

      resolve();
    }).catch(reject);
  });
};


//////////////////
// WEBPACK FOOTER
// /usr/share/hubspot/build/.hubspot/static-archive/conversations-internal-pub-sub/static-1.4265/js/ably/api-wrappers/playbackMessages.js
// module id = 786
// module chunks = 2 3